/**
 * Device fingerprinting utility for duplicate detection
 * Collects device information and creates a fingerprint hash
 */

export interface DeviceFingerprintData {
	userAgent: string;
	screenResolution?: string;
	timezone?: string;
	language?: string;
	platform?: string;
}

/**
 * Collect device information for fingerprinting
 */
export function collectDeviceFingerprint(): DeviceFingerprintData {
	const fingerprint: DeviceFingerprintData = {
		userAgent: navigator.userAgent || '',
	};

	// Screen resolution
	if (window.screen) {
		fingerprint.screenResolution = `${window.screen.width}x${window.screen.height}`;
	}

	// Timezone
	try {
		fingerprint.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	} catch (e) {
		// Timezone not available
	}

	// Language
	fingerprint.language = navigator.language || navigator.languages?.[0] || '';

	// Platform
	if (navigator.platform) {
		fingerprint.platform = navigator.platform;
	}

	return fingerprint;
}

/**
 * Hash sensitive data for privacy (client-side hashing before sending)
 * Note: This is a simple hash for privacy, not security
 */
export function hashSensitiveData(data: string): string {
	// Simple hash function (for privacy, not security)
	// In production, consider using Web Crypto API for better hashing
	let hash = 0;
	for (let i = 0; i < data.length; i++) {
		const char = data.charCodeAt(i);
		hash = ((hash << 5) - hash) + char;
		hash = hash & hash; // Convert to 32-bit integer
	}
	return Math.abs(hash).toString(16);
}

